/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ui_Filter_NameInputs */

const en_ui_filter_name = /** @type {(inputs: Ui_Filter_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`“${i?.value}”`)
};

const de_ui_filter_name = /** @type {(inputs: Ui_Filter_NameInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.value}“`)
};

/**
* | output |
* | --- |
* | "“{value}”" |
*
* @param {Ui_Filter_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_name = /** @type {((inputs: Ui_Filter_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_name(inputs)
	return de_ui_filter_name(inputs)
});